var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FancySelect",
    _vm._g(
      {
        ref: "fancyselect",
        staticClass: "selector",
        attrs: {
          disabled: _vm.disabled,
          options: _vm.donors,
          loading: _vm.loading,
          value: _vm.value,
          label: "name",
          filterable: false,
          clearable: _vm.clearable,
          placeholder: _vm.placeholder,
          noDrop: !_vm.query && !_vm.loading
        },
        on: { search: event => _vm.onSearch(event) },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function(donor) {
              return [
                donor.name !== "More Results"
                  ? [
                      donor.isHousehold
                        ? [
                            donor.primaryPerson.deceased
                              ? _c("strike", [
                                  _vm._v(_vm._s(donor.primaryPerson.firstName))
                                ])
                              : _c("span", [
                                  _vm._v(_vm._s(donor.primaryPerson.firstName))
                                ]),
                            _vm._v("   "),
                            donor.secondaryPerson
                              ? _c("span", [_vm._v("and")])
                              : _vm._e(),
                            _vm._v("   "),
                            donor.secondaryPerson
                              ? [
                                  donor.secondaryPerson.deceased
                                    ? _c("strike", [
                                        _vm._v(
                                          _vm._s(
                                            donor.secondaryPerson.firstName
                                          )
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            donor.secondaryPerson.firstName
                                          )
                                        )
                                      ]),
                                  _vm._v("   ")
                                ]
                              : _vm._e(),
                            _vm._v(
                              " " +
                                _vm._s(donor.primaryPerson.lastName) +
                                " (" +
                                _vm._s(donor.shortId) +
                                ") "
                            )
                          ]
                        : [
                            _vm._v(
                              _vm._s(donor.name) +
                                " (" +
                                _vm._s(donor.shortId) +
                                ")"
                            )
                          ],
                      _c("br"),
                      _c("layoutText", { staticClass: "address" }, [
                        _vm._v(_vm._s(donor.addressStr))
                      ])
                    ]
                  : [_vm._v("More results, keep typing to narrow down")]
              ]
            }
          }
        ])
      },
      _vm.listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }